/**
 * Route → tab-title mapping (router-free so it can be unit-tested without
 * importing react-router). Used by components/PageTitleManager.jsx.
 */

// Routes statiques → libellé d'onglet.
export const STATIC_TITLES = {
  // Public / auth
  '/login': 'Connexion',
  '/forgot-password': 'Mot de passe oublié',
  '/reset-password': 'Réinitialisation du mot de passe',
  '/accept-invitation': 'Invitation',
  // Espace client (portail)
  '/espace-client': 'Espace client',
  '/espace-client/login': 'Espace client — Connexion',
  '/espace-client/register': 'Espace client — Inscription',
  '/espace-client/mot-de-passe-oublie': 'Espace client — Mot de passe oublié',
  '/espace-client/dashboard': 'Espace client',
  '/espace-client/factures': 'Mes factures',
  '/espace-client/compteurs': 'Mes compteurs',
  '/espace-client/equipements': 'Mes équipements',
  '/espace-client/contrats': 'Mes contrats',
  '/espace-client/tickets': 'Mes tickets',
  '/espace-client/documents': 'Mes documents',
  '/espace-client/paiement-confirme': 'Paiement confirmé',
  // Admin app
  '/dashboard': 'Tableau de bord',
  '/commandes': 'Commandes',
  '/clients': 'Clients',
  '/contrats': 'Contrats',
  '/suivi-contrat': 'Suivi contrat',
  '/equipements': 'Équipements',
  '/abonnements': 'Abonnements',
  '/abonnements/import': 'Import abonnements',
  '/compteurs': 'Compteurs',
  '/demandes-compteurs': 'Demandes de compteurs',
  '/vitrine/demandes': 'Demandes de devis du site',
  '/vitrine/caracteristiques': 'Caractéristiques des fiches',
  '/vitrine/groupes': 'Groupes de caractéristiques',
  '/vitrine/gammes': 'Gammes de produits',
  '/vitrine/garanties': 'Garanties des fiches',
  '/facturation': 'Facturation',
  '/facturation/liste-factures': 'Factures',
  '/facturation/rentabilite': 'Rentabilité',
  '/mandats-sepa': 'Mandats SEPA',
  '/prelevements-sepa': 'Prélèvements SEPA',
  '/recovery': 'Recouvrement',
  '/tickets': 'Tickets',
  '/kpax-dashboard': 'Tableau de bord K-PAX',
  '/parametres': 'Paramètres',
  '/parametres/bibliotheque-equipements': 'Bibliothèque équipements',
  '/parametres/bibliotheque-abonnements': 'Bibliothèque abonnements',
  '/parametres/facturation': 'Paramètres facturation',
  '/parametres/produits-pennylane': 'Produits Pennylane',
  '/parametres/associations-kpax': 'Associations K-PAX',
  '/parametres/categories-tickets': 'Catégories de tickets',
  '/parametres/checklists-commandes': 'Checklists commandes',
  '/parametres/types-documents': 'Types de documents',
  '/parametres/bibliotheque-pub': 'Bibliothèque publicitaire',
  '/parametres/marques': 'Marques',
  '/parametres/avis': 'Avis',
  '/parametres/services': 'Services',
  '/parametres/indexation': 'Indexation',
  '/parametres/hubspot-sync': 'Synchronisation HubSpot',
  '/parametres/hubspot-config': 'Configuration HubSpot',
  '/parametres/synchronisations-audit': 'Audit synchronisations',
  '/parametres/champs-locaux': 'Champs locaux',
  '/parametres/modeles-factures': 'Modèles de factures',
  '/parametres/emails': 'E-mails',
  '/parametres/commissions': 'Paramètres commissions',
  '/espace-client-gestion': 'Gestion espace client',
  '/admin': 'Administration',
  '/admin/utilisateurs': 'Utilisateurs',
  '/admin/jobs': 'Jobs',
  '/admin/logs': 'Logs',
  '/documentation-technique': 'Documentation technique',
  '/formation': 'Formation',
  '/commercial/dashboard': 'Tableau de bord commercial',
  '/commercial/clients': 'Clients (commercial)',
  '/commercial/renouvellements': 'Renouvellements',
  '/commercial/secteurs': 'Secteurs',
  '/commercial/catalogue': 'Catalogue',
  '/commercial/commissions': 'Commissions',
  '/etudes-comparatives': 'Études comparatives',
  '/commercial/devis': 'Devis',
  '/commercial/relances': 'Relances',
  '/commercial/devis-parametrage': 'Paramétrage devis',
  '/commercial/devis-modeles': 'Modèles de devis',
  '/commercial/devis-modeles-mail': "Modèles d'e-mail devis",
};

// Routes dynamiques (détail / jeton) → libellé. Ordre : plus spécifique d'abord.
export const PATTERN_TITLES = [
  [/^\/soumettre-compteur\/[^/]+$/, 'Relevé compteur'],
  [/^\/avis\/[^/]+$/, 'Avis'],
  [/^\/commande\/documents\/[^/]+$/, 'Documents commande'],
  [/^\/devis\/consulter\/[^/]+$/, 'Devis'],
  [/^\/espace-client\/equipements\/[^/]+$/, 'Équipement'],
  [/^\/espace-client\/contrats\/[^/]+$/, 'Contrat'],
  [/^\/espace-client\/tickets\/[^/]+$/, 'Ticket'],
  [/^\/commandes\/[^/]+$/, 'Commande'],
  [/^\/clients\/[^/]+\/synchronisations$/, 'Synchronisations client'],
  [/^\/clients\/[^/]+$/, 'Client'],
  [/^\/contrats\/[^/]+$/, 'Contrat'],
  [/^\/equipements\/[^/]+$/, 'Équipement'],
  [/^\/recovery\/client\/[^/]+$/, 'Recouvrement client'],
  [/^\/tickets\/[^/]+$/, 'Ticket'],
  [/^\/formation\/module\/[^/]+$/, 'Module de formation'],
  [/^\/formation\/section\/[^/]+$/, 'Section de formation'],
  [/^\/commercial\/clients\/[^/]+$/, 'Fiche client'],
  [/^\/etudes-comparatives\/[^/]+$/, 'Étude comparative'],
  [/^\/commercial\/devis\/[^/]+$/, 'Devis'],
];

export function titleForPath(pathname) {
  if (!pathname) return '';
  const clean = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  if (STATIC_TITLES[clean]) return STATIC_TITLES[clean];
  for (const [re, label] of PATTERN_TITLES) {
    if (re.test(clean)) return label;
  }
  return '';   // inconnu → « Hélios » seul
}
